import { TemplatesFieldsTable } from "@/components/partial";

function AdminDocumentTemplateFields() {
  return <TemplatesFieldsTable />;
}

export default AdminDocumentTemplateFields;
